import React from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import {
  Container,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import EcommerceProductsTable from "./EcommerceProductsTable"
import "../../../assets/scss/custom.scss"

const EcommerceProducts = props => {
  return (
    <>
      {
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Products | EEFind </title>
            </MetaTags>
            <Container fluid>
              <Breadcrumbs title="Dashboard" breadcrumbItem="Products in Shops" />
              <EcommerceProductsTable
                queryCondition={null}
                activeFilters={["product_brand", "category", "subcategory", "store", "store_type", "created_at", "non_mrp"]}
                filterQueryConditions={null}
              />
            </Container>
          </div>
        </React.Fragment>
      }
    </>
  )
}
EcommerceProducts.propTypes = {}
export default withRouter(EcommerceProducts)
